import axios from 'axios'

const instance = axios.create({
    baseURL: "https://asuserver-ej5ruy93z-ladeadev.vercel.app",
    headers:{
        password: "sadasd9mU8Q3YD70q3rt620&#%$E&*@#%B(DR&(#%b9IDBSDHUR#(@DRBAW&RD#B(&D"
    },
})

export default instance